/* ------------------------------------------- */
/*   Media List Reducer
/*   Responsible for the slice of state containing media items retrieved from API
/* ------------------------------------------- */

import { createReducer } from 'AppSrc/core/reducers/create-reducer';
import {
  CREATE_WORK_INFO_ITEMS_REQUEST,
  CREATE_WORK_INFO_ITEMS_SUCCESS,
  CREATE_WORK_INFO_ITEMS_ERROR,
  WORK_INFO_ITEM_ATTACHMENT_READ,
  CRQ_WORK_ITEMS_FETCHED,
} from 'AppSrc/core/work-info-items/work-info-item-actions';

const workInfoItemReducerDefaultState = {
  isSaving: false,
  workInfoItemsByCrqId: {},
  // array of the file ids that have been read into memory
  // during saving of work info items
  // used to display progress
  attachmentsRead: [],
};


const createWorkInfoItemsRequest = (state, action) => ({
  ...state,
  isSaving: true,
});

const createWorkInfoItemsSuccess = (state, action) => ({
  ...state,
  isSaving: false,
  workInfoItemsByCrqId: {
    ...state.workInfoItemsByCrqId,
    [action.payload.crqId]: action.payload.workInfoItems,
  },
  attachmentsRead: [],
});

const createWorkInfoItemsError = (state, action) => ({
  ...state,
  isSaving: false,
  attachmentsRead: [],
});

const workInfoItemAttachmentRead = (state, action) => ({
  ...state,
  attachmentsRead: [
    ...state.attachmentsRead,
    action.payload.fileId,
  ],
});

const crqWorkItemsFetched = (state, action) => ({
  ...state,
  workInfoItemsByCrqId: {
    ...state.workInfoItemsByCrqId,
    [action.payload.crqId]: action.payload.workInfoItems,
  },
});

// Action handlers dictionary
// defines the mapping between actions and the handler methods
const actionHandlers = {
  [CREATE_WORK_INFO_ITEMS_REQUEST]: createWorkInfoItemsRequest,
  [CREATE_WORK_INFO_ITEMS_SUCCESS]: createWorkInfoItemsSuccess,
  [CREATE_WORK_INFO_ITEMS_ERROR]: createWorkInfoItemsError,
  [WORK_INFO_ITEM_ATTACHMENT_READ]: workInfoItemAttachmentRead,
  [CRQ_WORK_ITEMS_FETCHED]: crqWorkItemsFetched,
};

// create the reducer
const workInfoItemReducer = createReducer(workInfoItemReducerDefaultState, actionHandlers);

export {
  workInfoItemReducerDefaultState,
  workInfoItemReducer,
};
